<template>
  <div class="c-w-100">
    <div
      v-if="!isLoading"
      style="height: max-content; min-height: max-content; max-height: max-content"
      class="is-flex is-flex-direction-column is-justify-content-space-between is-align-items-center c-w-100 gap-5"
    >
      <div class="group-date-wrapper c-w-100" v-if="jadwalPekerjaan.length > 0">
        <div class="is-flex is-justify-content-space-between averta-bold mb-4">
          <p>Pilih Tanggal Pekerjaan</p>
          <p>{{ jadwalMonth }}</p>
        </div>
        <div class="is-relative">
          <div
            class="is-flex overflow-auto scroll-smooth"
            ref="contentJadwal"
            @scroll="checkScrollJadwal"
          >
            <div
              class="parent-date-wrapper mb-3"
              :class="{
                'mr-3': indexDate + 1 === jadwalPekerjaan.length,
                'ml-3': indexDate + 1 === 1
              }"
              v-for="(itemDate, indexDate) in jadwalPekerjaan"
              :key="`${indexDate}_date_working`"
            >
              <div
                class="date-wrapper cursor-pointer"
                :class="{ active: selectedDate === itemDate.completeDate }"
                @click="handleSelectedDate(itemDate.completeDate)"
              >
                <p class="averta-bold">{{ itemDate.date }}</p>
              </div>
              <p
                class="white-space-nowrap"
                :class="{ 'has-text-weight-bold': selectedDate === itemDate.completeDate }"
              >
                {{ itemDate.day }}
              </p>
              <p
                v-if="showExtend(itemDate.completeDate)"
                class="color-grey"
                :class="{ 'averta-bold color-blue-1': selectedDate === itemDate.completeDate }"
              >
                <i>Extend</i>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Headline Title -->
      <div
        class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center c-w-100"
      >
        <div
          class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center c-w-100"
        >
          <div
            class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start"
          >
            <p class="averta-bold label-18">Rekap Upah Tukang</p>
            <p class="averta-regular label-14">Tanggal: {{ formatSelectedDate }}</p>
          </div>
        </div>
        <div
          class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center c-w-100"
        >
          <ButtonApp :isSecondary="true" @click="downloadExcel">
            <div
              class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center gap-3"
            >
              <p class="averta-bold py-2">Download As Excel</p>
              <DownloadIcon />
            </div>
          </ButtonApp>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="isLoadingSelectedDate" class="loading-wrapper c-w-100 c-h-100 border-radius-10">
        <SpinnerIcon />
      </div>
      <!-- Loading -->

      <!-- Table Rekap Upah Tukang -->
      <div
        v-else
        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100"
      >
        <div class="table-container">
          <!-- Header Table -->
          <div class="header-table">
            <div class="header-table-row-item" style="max-width: 50px">
              <p class="averta-semibold label-12">No.</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Nama Tukang</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Keahlian yang Digunakan</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Upah per Keahlian</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Sesi Pekerjaan</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Status Absen</p>
            </div>
            <div class="header-table-row-item">
              <p class="averta-semibold label-12">Total Upah</p>
            </div>
          </div>

          <!-- Body Table -->
          <div v-if="transformedWorkers.length > 0" class="c-w-100 c-h-100">
            <div
              v-for="(worker, index) in transformedWorkers"
              :key="worker.worker_id"
              class="body-table"
            >
              <!-- No -->
              <div
                class="body-table-row-item"
                :style="{ 'min-height': worker.skills.length * heightTable + 'px' }"
                style="max-width: 50px; align-items: flex-start"
              >
                <div
                  class="is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start c-w-100 c-h-100 p-2"
                >
                  <p class="averta-semibold label-12">{{ index + 1 }}</p>
                </div>
              </div>

              <!-- Nama Tukang -->
              <div class="body-table-row-item" style="align-items: flex-start">
                <div
                  :style="{ 'min-height': worker.skills.length * heightTable + 'px' }"
                  class="is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start c-w-100 c-h-100 p-2"
                >
                  <div
                    class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-flex-start gap-3"
                  >
                    <div class="bullet-element" style="overflow: hidden">
                      <img :src="worker.worker_image" alt="" />
                    </div>
                    <div
                      class="is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start gap-1"
                    >
                      <p class="averta-semibold label-12">{{ worker.worker_name }}</p>
                      <p class="averta-reguler label-12 color-gray">{{ worker.worker_id }}</p>
                      <span
                        @click="handleOpenModalsPreviewSertifikat(worker.worker_id, worker)"
                        v-if="worker.certificates.length > 0"
                        class="badge-new-comment gap-2 is-clickable"
                      >
                        <SertifikatBadgeIcon />
                        <p class="m-0 label-10 averta-bold-italic color-green">Bersertifikat</p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Keahlian yang Digunakan -->
              <div class="body-table-row-item">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 c-h-100 p-0 m-0"
                >
                  <div
                    v-for="skill in worker.skills"
                    :key="skill.skill_id"
                    class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-flex-start gap-3 c-w-100 c-h-100 p-2 border-skill-workers height-table"
                  >
                    <div class="bullet-element" style="overflow: hidden">
                      <img :src="skill.skill_image" alt="" />
                    </div>
                    <p style="line-height: 15px" class="averta-semibold label-12 c-w-80">{{ skill.skill_name }}</p>
                  </div>
                </div>
              </div>

              <!-- Upah per Keahlian -->
              <div class="body-table-row-item">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 c-h-100"
                >
                  <div
                    v-for="skill in worker.skills"
                    :key="skill.skill_id"
                    class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-flex-start c-w-100 c-h-100 p-2 border-skill-workers height-table"
                  >
                    <p class="averta-reguler label-12">Rp.</p>
                    <p class="averta-semibold label-12">{{ formatPrice(skill.payment || 0) }}</p>
                  </div>
                </div>
              </div>

              <!-- Sesi Pekerjaan -->
              <div class="body-table-row-item" style="align-items: flex-start">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 c-h-100"
                >
                  <div
                    v-for="skill in worker.skills"
                    :key="skill.skill_id"
                    class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-flex-start c-w-100 c-h-100 p-2 gap-2 border-skill-workers height-table"
                  >
                    <span
                      class="element-session-workers px-3"
                      :class="sessionWorker(skill.session_description, 'background')"
                    >
                      <p class="averta-bold label-12 color-white">
                        {{ sessionWorker(skill.session_description, 'stand-for') }}
                      </p>
                    </span>
                    <p class="averta-semibold label-12">
                      {{ skill.session_description }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Status Absen -->
              <div class="body-table-row-item" style="align-items: flex-start">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 c-h-100"
                >
                  <div
                    v-for="skill in worker.skills"
                    :key="skill.skill_id"
                    class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-flex-start c-w-100 c-h-100 p-2 gap-2 border-skill-workers height-table"
                  >
                    <p
                      class="averta-semibold-italic label-12"
                      :class="{
                        'color-green': skill.attendance_status === true,
                        'color-red': skill.attendance_status === false
                      }"
                    >
                      {{ getStatusText(skill.attendance_status) }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Total Upah -->
              <div
                class="body-table-row-item"
                style="align-items: flex-start"
                :style="{ 'min-height': worker.skills.length * heightTable + 'px' }"
              >
                <div
                  v-if="
                    worker.selected_payment &&
                    worker.selected_skill_id &&
                    worker.selected_skill_image
                  "
                  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 c-h-100 p-2"
                >
                  <div
                    class="is-flex is-flex-direction-row is-justify-content-center is-align-items-flex-start gap-3 c-w-100 c-h-100"
                  >
                    <div class="bullet-element" style="overflow: hidden">
                      <img :src="worker.selected_skill_image" alt="" />
                    </div>
                    <div
                      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start gap-1 c-w-100 c-h-100"
                    >
                      <p class="averta-semibold label-12">
                        {{ worker.selected_skill_name }}
                      </p>
                      <p class="averta-reguler label-12 color-gray">
                        Rp{{ worker.selected_payment }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  style="max-height: 100% !important; height: 100% !important"
                  class="is-flex is-flex-direction-column is-justify-content-flex-start is-align-items-flex-start c-w-100 c-h-100 p-2 height-table"
                >
                  <p class="averta-semibold-italic label-12 color-gray">Belum Hadir</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div v-else class="body-table">
            <div class="body-table-row-item" colspan="7" style="text-align: center; padding: 2rem">
              <p class="averta-semibold-italic label-12 color-red">
                {{
                  selectedDate
                    ? 'Tidak ada data untuk tanggal yang dipilih'
                    : 'Pilih tanggal untuk melihat data'
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div v-else>
      <SpinnerIcon />
    </div>
    <!-- Loading -->

    <ModalsPreviewSertifikat
      :isHandleOpenModalsPreviewSertifikat="isHandleOpenModalsPreviewSertifikat"
      :selectWorkers="selectWorkers"
      @closeModalPreviewSertifikat="closeModalPreviewSertifikat"
    />
  </div>
</template>

<script>
import moment from 'moment'
import ButtonApp from '@/components/button/ButtonApp.vue'
import { mapGetters } from 'vuex'
import { DownloadIcon, SertifikatBadgeIcon, SpinnerIcon } from '@/components/icons'
import { formatSessionWorker, sesiStatusInformation } from '@/helpers'
import ModalsPreviewSertifikat from '@/components/modal/ModalsPreviewSertifikat.vue'
import _ from 'lodash'

export default {
  name: 'TabRekapUpahTukang',
  props: {
    dataHeader: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ButtonApp,
    DownloadIcon,
    SertifikatBadgeIcon,
    SpinnerIcon,
    ModalsPreviewSertifikat
  },
  data () {
    return {
      dataListWorkers: [],
      isLoading: false,
      dataDialyReport: null,
      jadwalPekerjaan: [],
      jadwalMonth: '',
      selectedDate: null,
      animated: true,
      isLoadingSelectedDate: false,
      isHandleOpenModalsPreviewSertifikat: false,
      selectWorkers: {},
      heightTable: 65
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user',
      getDateWorking: 'project/getDateWorking'
    }),

    getDataHeader () {
      return this.dataHeader
    },

    formatSelectedDate () {
      if (!this.selectedDate) return 'Belum dipilih'
      return moment(this.selectedDate).format('DD MMMM YYYY')
    },

    transformedWorkers () {
      if (!this.dataListWorkers || !Array.isArray(this.dataListWorkers)) {
        return []
      }

      return this.dataListWorkers.map((worker) => {
        const totalWage = worker.skills.reduce((total, skill) => {
          return skill.absence_status ? total + skill.payment : total
        }, 0)

        const rawCertificates =
          !_.isArray(worker.certificate) && _.isObject(worker.certificate)
            ? [worker.certificate]
            : worker.certificate || []

        const normalizedCertificates = rawCertificates.map((c) => ({
          certificate_no: _.get(c, 'no', ''),
          certificate_date: _.get(c, 'date', ''),
          certificate_image: _.get(c, 'image', ''),
          certificate_pdf: _.get(c, 'pdf', '')
        }))

        return {
          worker_id: worker.id,
          worker_name: worker.name,
          worker_image: worker.image,
          certificates: normalizedCertificates,
          skills: worker.skills.map((skill) => ({
            skill_id: skill.skill_id,
            skill_name: skill.skill_name,
            skill_image: skill.skill_image,
            sesi: this.getSessionLabel(skill.session_description),
            session_description: skill.session_description,
            payment: skill.payment,
            attendance_status: skill.absence_status,
            worker_skill_id: skill.worker_skill_id
          })),
          total_wage: totalWage,
          selected_skill_id: worker.selected_skill_id,
          selected_skill_image: worker.selected_skill_image,
          selected_payment: worker.selected_payment
        }
      })
    }
  },
  methods: {
    sessionWorker (status, type) {
      if (type === 'consultan') {
        return 'bg-blue-separate'
      }
      const dataSessionProps = {
        status
      }
      if (type === 'background') {
        dataSessionProps.isForBackground = true
        if (!status) {
          return 'bg-white'
        }
      }
      if (type === 'stand-for') {
        dataSessionProps.isStandFor = true
      }
      return formatSessionWorker(dataSessionProps)
    },

    getSessionLabel (sessionDescription) {
      if (!sessionDescription) return 'N/A'

      const sessionMap = {
        '08:00-12.00': 'Pagi',
        '13:00-17.00': 'Sore',
        '22:00-05.00': 'Malam'
      }

      return sessionMap[sessionDescription] || sessionDescription
    },

    getStatusText (status) {
      return status === true ? 'Sudah Hadir' : 'Belum Hadir'
    },

    formatPrice (price) {
      return price.toLocaleString('id-ID')
    },

    async getInformationWorkerSalary (selectedDate = null) {
      if (!this.getDataHeader?.project_homecare_id) {
        console.warn('Project homecare ID not found')
        return
      }

      const dateToUse = selectedDate || this.selectedDate

      if (!dateToUse) {
        console.warn('No date selected')
        return
      }

      const payload = {
        url: this.url,
        worker_id: this.getDataHeader.project_homecare_id,
        selected_date: dateToUse
      }

      try {
        const response = await this.$store.dispatch('project/getInformationWorkerSalary', payload)
        this.dataListWorkers = response.data.data || {}
      } catch (error) {
        console.error('Gagal memuat data upah tukang:', error)
        this.dataListWorkers = []
      } finally {
        setTimeout(() => {
          this.isLoading = false
          this.isLoadingSelectedDate = false
        }, 1200)
      }
    },

    getJadwalPekerjaan () {
      if (this.isLoading || !this.dataDialyReport) return

      moment.locale('id')
      const arr = []
      const defaultFormat = 'YYYY-MM-DD'
      const startDate = moment(this.dataDialyReport.start_date, defaultFormat)
      const endDate = moment(this.dataDialyReport.end_date, defaultFormat)
      const currentDate = moment().format(defaultFormat)
      const formatDate = startDate.clone()
      const startFormat = startDate.format('MMMM')
      const endFormat = endDate.format('MMMM YYYY')

      if (startDate.format('MM') === endDate.format('MM')) {
        this.jadwalMonth = `${startFormat} ${startDate.format('YYYY')}`
      } else {
        this.jadwalMonth = `${startFormat} ${
          startDate.format('YYYY') !== endDate.format('YYYY') ? startDate.format('YYYY') : ''
        } - ${endFormat}`
      }

      while (formatDate.isSameOrBefore(endDate)) {
        const completeDate = formatDate.format(defaultFormat)
        const date = formatDate.format('DD')
        let day = formatDate.format('ddd')

        if (currentDate === completeDate) {
          day = 'Hari ini'
        }

        const tempDate = {
          completeDate,
          date,
          day
        }
        arr.push(tempDate)
        formatDate.add(1, 'days')
      }

      this.jadwalPekerjaan = arr

      const todayDate = moment().format(defaultFormat)
      const availableToday = arr.find((item) => item.completeDate === todayDate)

      if (availableToday) {
        this.selectedDate = todayDate
      } else if (arr.length > 0) {
        this.selectedDate = arr[0].completeDate
      }

      if (this.selectedDate) {
        this.getInformationWorkerSalary(this.selectedDate)
      }

      this.checkScrollJadwal()
    },

    handleSelectedDate (date) {
      this.isLoadingSelectedDate = true
      if (this.selectedDate === date) return

      this.selectedDate = date
      this.getInformationWorkerSalary(date)
    },

    showExtend (date) {
      return false
    },

    checkScrollJadwal () {},

    downloadExcel () {
      this.isLoading = true

      const payload = {
        url: this.url,
        worker_id: this.getDataHeader.project_homecare_id
      }

      this.$store
        .dispatch('project/downloadInformationWorkerSalary', payload)
        .then((response) => {
          const result = response.data
          const path = result.path

          const url = `${process.env.VUE_APP_SHELL_URL_SOCKET}/${path}`
          window.location.href = url

          this.isLoading = false
        })
        .catch((error) => {
          console.error('Error downloading Excel:', error)
          this.isLoading = false
        })
    },
    handleOpenModalsPreviewSertifikat (workersId, workers) {
      this.selectWorkers = { workersId, ...workers }
      this.isHandleOpenModalsPreviewSertifikat = true
    },
    closeModalPreviewSertifikat () {
      this.isHandleOpenModalsPreviewSertifikat = false
    }
  },

  watch: {
    dataHeader: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.dataListWorkers = []
          this.selectedDate = null
          if (this.dataDialyReport) {
            this.getJadwalPekerjaan()
          }
        }
      },
      immediate: true,
      deep: true
    },

    getDateWorking: {
      handler (newVal) {
        if (newVal) {
          this.dataDialyReport = newVal
          this.getJadwalPekerjaan()
        } else {
          this.dataDialyReport = null
          this.jadwalPekerjaan = []
          this.selectedDate = null
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.isLoading = true
    this.dataListWorkers = this.dataListWorkers.map((item) => {
      item.skill.session_description = sesiStatusInformation(item.skill.session_description)
      return item
    })
  }
}
</script>

<style scoped>
.table-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e1e1e1;
}

.header-table {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 50px;
  min-height: 50px;
  max-height: 50px;
  margin: 0;
  padding: 0;
  background: #ffffff;
  border-bottom: 1px solid #e1e1e1;
}

.header-table-row-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: none;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  border-right: 1px solid #e1e1e1;
  background: #ffffff;
}

.header-table-row-item:last-child {
  border-right: none;
}

.body-table {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: max-content;
  min-height: max-content;
  max-height: max-content;
  margin: 0;
  padding: 0;
  background: #ffffff;
  border-bottom: 1px solid #e1e1e1;
}

.body-table:last-child {
  border-bottom: none;
}

.body-table-row-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: none;
  max-width: 100%;
  height: 100%;
  min-height: 65px;
  max-height: 100%;
  margin: 0;
  padding: 0;
  border-right: 1px solid #e1e1e1;
  background: #ffffff;
}

.height-table {
  min-height: 65px;
}

.body-table-row-item:last-child {
  border-right: none;
}

.bullet-element {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  margin: 0;
  padding: 0;
  background: #ffffff;
  border-radius: 50%;
}

.badge-new-comment {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: auto;
  max-width: auto;
  height: auto;
  margin: 0;
  padding: 0.25rem 0.5rem;
  background: #ecfaf0;
  border-radius: 1000px;
}

.element-session-workers {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  margin: 0;
  padding: 0;
  background: #65b741;
  border-radius: 2.5px;
}

.border-skill-workers {
  border-bottom: 1px solid #e1e1e1;
}

.border-skill-workers:last-child {
  border-bottom: none;
}

.group-date-wrapper {
  padding: 1em;
  border: 1px solid #e1e1e1;
  background: #fafafa;
  border-radius: 20px;
}

.parent-date-wrapper {
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  margin-right: 5em;
}

.date-wrapper {
  width: 35px;
  height: 35px;
  border-radius: calc(35px / 2);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ease 0.5s;
}

.date-wrapper.active {
  color: white;
  background: linear-gradient(90deg, #891313 0%, #d92727 99.97%);
}

/* Utility classes */
.color-green {
  color: #28a745;
}
.color-gray {
  color: #6c757d;
}
.color-red {
  color: #dc3545;
}
.color-blue-1 {
  color: #007bff;
}
</style>
